import type { OnCreateAppSync } from 'vike-vue/types'
import { createI18n } from 'vue-i18n'
import frLocales from '@/i18n/locales/fr-FR.json'
import NuxtImg from '@/components/NuxtImg.vue'
import NuxtLink from '@/components/NuxtLink.vue'
import { gtm } from '@/gtm'
import eumPlugin from '@/eum'
import instanaPlugin from '@/instana'

declare global {
  // eslint-disable-next-line no-var
  var __VUE_PROD_DEVTOOLS__: boolean
}

const i18n = createI18n({
  locale: 'fr',
  messages: {
    fr: frLocales,
  },
})

export const onCreateApp: OnCreateAppSync = (pageContext) => {
  if (pageContext.isRenderingHead) return
  const { app } = pageContext
  app.component('NuxtImg', NuxtImg)
  app.component('NuxtLink', NuxtLink)

  // https://vike.dev/vue-i18n
  // https://github.com/vikejs/vike/discussions/1778#discussioncomment-10192261
  if (!('__VUE_PROD_DEVTOOLS__' in globalThis)) {
    globalThis.__VUE_PROD_DEVTOOLS__ = false
  }

  app.use(i18n)
  app.use(eumPlugin)

  app.use(instanaPlugin)

  if (import.meta.env.PUBLIC_ENV__GTM_CONTAINER_ID) app.use(gtm)
}
